/** "See plans": what follows every message saying a plan does not allow something, or, for the
 * photos a downgrade left, the way to Your data. */

import { Link } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";

export function UpgradeLink({
  label,
  to = "/settings/billing",
}: {
  label?: string;
  to?: "/settings/billing" | "/settings/data";
}) {
  const { t } = useTranslation();
  return (
    <Link to={to} className="text-brand-700 font-medium whitespace-nowrap underline">
      {label ?? t("billing.seePlans")}
    </Link>
  );
}
